require("../sass/style.scss");

// require("../fonts/fontello/css/fontello.css");

import "swiper/css/bundle";

// require("./vendor/bootstrap-transition");
// require("./vendor/bootstrap-collapse");


(function ($) {

    require("./custom/header.es6");
    require("./custom/global-forms.es6");

    $(".scroll-line-element.animated").length > 0 && require("./custom/scroll-line-element.es6");
    $(".b2b-custom-login-form, .b2b-custom-registration-form, .custom-partners-form").length > 0 && require("./custom/b2b-registration-login-form-elements.es6");
    $("form.woocommerce-form-login.login, form.woocommerce-form-register.register").length > 0 && require("./custom/login-popup.es6");
    $(".lost_reset_password").length > 0 && require("./custom/reset-lost-password.es6");
    $("[data-store-locator]").length > 0 && require("./custom/store-locator-element.es6");
    $(".spraga-share-trigger").length > 0 && require("./custom/single-product-share.es6");
    $(".spraga-variation-search").length > 0 && require("./custom/variation-search.es6");
    $(".spraga-products-overview").length > 0 && require("./custom/products-overview.es6");
    $("[data-press-load-more]").length > 0 && require("./custom/press-element.es6");
    $(".spraga-open-reviews").length > 0 && require("./custom/product-reviews-popups.es6");
    require("./custom/ajax-add-to-cart.es6");

    if ($(".woocommerce-checkout").length > 0) {
        require("./custom/checkout.es6");
    }
    require("./custom/wishlist-popup.es6");
    require("./custom/subscribe");

    if ($(".section-custom-accordion, .section-custom-accordion-type-2").length > 0) {
        require("./custom/section-custom-accordion.es6");
    }

    if ($(".page-wrapper.my-account").length > 0) {
        require("./custom/account_details.es6");
    }


    // wc_message_hidden

    const COOKIE = 'wc_notice_time';
    const COOKIE_TTL_SEC = 10;

    function hasCookie(name) {
        return new RegExp('(?:^|;\\s*)' + name + '=').test(document.cookie);
    }

    function setCookieOnce() {
        if (hasCookie(COOKIE)) return;

        const ts = Math.floor(Date.now() / 1000);

        // Comments in English as you prefer
        document.cookie =
            COOKIE + '=' + ts +
            '; max-age=' + COOKIE_TTL_SEC +
            '; path=/' +
            '; samesite=lax';
        // + '; secure'; // enable if HTTPS
    }

    /**
     * Hide notices after TTL.
     * Each notice is handled once (via data attr), so repeated observer hits won't restart timers.
     */
    function hideNotices($notices) {
        if (!$notices || !$notices.length) return;

        $notices.each(function () {
            const $n = $(this);

            if ($n.attr('data-wc-notice-hidden') === '1') return;
            $n.attr('data-wc-notice-hidden', '1');

            setCookieOnce();

            setTimeout(function () {
                // Notice may already be removed by another script
                if (!$n.closest('body').length) return;

                $n.fadeOut(300, function () {
                    $n.remove();
                });
            }, COOKIE_TTL_SEC * 1000);
        });
    }

    function handleNotices() {
        hideNotices($('.woocommerce-message, .woocommerce-error, .woocommerce-info'));
    }

    // Initial
    handleNotices();

    // Woo events (optional, but fine to keep)
    $(document.body).on(
        'wc_fragments_loaded wc_fragments_refreshed added_to_cart',
        handleNotices
    );

    // Also try common wishlist events (optional)
    $(document.body).on(
        'removed_from_wishlist added_to_wishlist wishlist_page_refreshed',
        handleNotices
    );

    // Robust: observe DOM for notices added by any AJAX (YITH included)
    (function initNoticeObserver() {
        if (!window.MutationObserver) return;

        const obs = new MutationObserver(function (mutations) {
            for (const m of mutations) {
                if (!m.addedNodes || !m.addedNodes.length) continue;

                for (const node of m.addedNodes) {
                    if (!node || node.nodeType !== 1) continue;

                    // If the added node is itself a notice
                    if (node.matches && node.matches('.woocommerce-message, .woocommerce-error, .woocommerce-info')) {
                        hideNotices($(node));
                        continue;
                    }

                    // Or contains notices inside
                    if (node.querySelectorAll) {
                        const inner = node.querySelectorAll('.woocommerce-message, .woocommerce-error, .woocommerce-info');
                        if (inner && inner.length) {
                            hideNotices($(inner));
                        }
                    }
                }
            }
        });

        obs.observe(document.body, { childList: true, subtree: true });
    })();

})(jQuery);